module.exports = __webpack_public_path__ + "static/media/wyb5d.2ce783b1.mp4";